import React, { Component } from "react";
import PropTypes from "prop-types";
import { FORM_FIELD_TYPE } from "../../../../constants";
import RightPanel from "../../../common/RightPanel";
import Form from "../../../common/Form";

export default class EditCampaignTargetType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignTargetType: props.campaignTargetType,
      hasEditError: false,
    };
  }

  static propTypes = {
    campaignTargetType: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    this.setState({ campaignTargetType: this.props.campaignTargetType });
  };

  cancelEdit = () => {
    this.setState({ hasEditError: false, campaignTargetType: {} });
    this.props.onClose();
  };

  isValid = (campaignTargetType) => {
    if (campaignTargetType.name.trim().length === 0) return false;
    return true;
  };

  save = () => {
    const { actions } = this.props;
    const { campaignTargetType } = this.state;
    if (!this.isValid(campaignTargetType)) {
      this.setState({ hasEditError: true });
      return;
    }
    actions.saveOrUpdateCampaignTargetType(campaignTargetType);
    this.cancelEdit();
  };

  inputOnChange = (value, accessor) => {
    const { campaignTargetType } = this.state;
    this.setState({
      campaignTargetType: { ...campaignTargetType, [accessor]: value },
    });
  };

  render = () => {
    const { isOpen } = this.props;
    const { campaignTargetType = {}, hasEditError } = this.state;
    return (
      <RightPanel
        isOpen={isOpen}
        onClose={() => this.cancelEdit()}
        header={
          campaignTargetType.id
            ? "RightPanelHeader.editCampaignTargetType"
            : "RightPanelHeader.addCampaignTargetType"
        }
        isEdit={campaignTargetType.id ? true : false}
        showFooter={true}
        primaryButtonProps={{ text: "Button.save", onClick: this.save }}
        secondaryButtonProps={{ text: "Button.cancel", onClick: this.cancelEdit }}
      >
        <Form
          config={[
            {
              type: FORM_FIELD_TYPE.INPUT,
              label: "Name",
              className: "col-12",
              placeholder: "Enter Name",
              value: campaignTargetType.name,
              error: hasEditError && campaignTargetType.name.trim().length === 0,
              errorMessage: "Enter Valid Name",
              onChange: (e) => this.inputOnChange(e.target.value, "name"),
            },
          ]}
        />
      </RightPanel>
    );
  };
}
